import { ApiCore } from '@/services/api/utils/core.js'
import axios from "axios";
import { apiProvider } from "@/services/api/utils/provider.js";
import { handleResponse, handleError } from "@/services/api/utils/response.js";

const url = 'v1/get-messages'
const plural = 'messages'
const single = 'message'

const transaction = new ApiCore({
	index: true,
	create: true,
	findOne: true,
	url: url,
	plural: plural,
	single: single,
})

transaction.activityLog = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/eventLog/messageStore/${id}`)
		.then(handleResponse)
		.catch(handleError);
};

transaction.activityLogByTransactionRequestId = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/eventLog/transactionRequest/${id}`)
		.then(handleResponse)
		.catch(handleError);
};

export default transaction
